import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function updateVisibleEdges(swiper) {
    swiper.slides.forEach(slide => {
        slide.classList.remove('is-first-visible', 'is-last-visible');
    });
    const visible = [...swiper.slides].filter(s => s.classList.contains('swiper-slide-visible'));
    if (visible.length > 0) {
        visible[0].classList.add('is-first-visible');
        visible[visible.length - 1].classList.add('is-last-visible');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.historyTimelineSlider');
    for (const slider of sliders) {
        new Swiper(slider, {
            modules: [Navigation],
            loop: false,
            spaceBetween: 12,
            watchSlidesProgress: true,
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                1250: { slidesPerView: 4 },
                1024: { slidesPerView: 3 },
                768:  { slidesPerView: 3 },
                0:    { slidesPerView: 2 },
            },
            on: {
                init:                     updateVisibleEdges,
                slideChange:              updateVisibleEdges,
                slideChangeTransitionEnd: updateVisibleEdges,
                resize:                   updateVisibleEdges,
            },
        });
    }
});
